export default "__VITE_ASSET__gXsWuLWV__"